import { createPersistedStorage } from "src/utility/storage";
import { MenuKeysType } from "src/constants";
import { Theme } from "./slices/client/client.type";

export type MenuItemType = {
  clientId: string;
  type: MenuKeysType;
};

export const persistedTheme = createPersistedStorage<Theme>("rc.clientTheme");
export const persistedModules = createPersistedStorage<MenuItemType[]>("rc.modules");
